module.exports = {
	"next": "下一步",
	"skip": "跳转到Cozy创建",
	"cancel": "取消",
	"back": "后退",
	"sign up": "注册",
	"add email": "添加电邮账号",
	"welcome": "让我进来！",
	"confirm": "确认",
	"user missing properties": "对不起此用户不存在",
	"step welcome user": "欢迎 %{name}！",
	"step welcome anon": "欢迎！",
	"step welcome logout": "你不是 %{name}？",
	"step welcome congrats": "恭喜，多亏了你，你的个人数据待在一个安全的地方，你的Cozy。",
	"step welcome next": "下一步",
	"step agreement title": "服务条款",
	"step agreement subtitle": "要访问你的Cozy，您必须阅读和同意我们的服务条款。但作为人类，我们猜你不会阅读所有条款。这里是一个为你制作的简短版本：",
	"step agreement element 0": "控制和负责你的数据，就在家里！",
	"step agreement element 1": "我们会照顾你和你的Cozy...",
	"step agreement element 2": "...除非你对Cozy或者你的数据做错了什么",
	"step agreement element 3": "选择哪种服务可以使用你的数据和明白他们的目标",
	"step agreement element 4": "没有人(甚至我们)可以访问在你的Cozy上属于你的数据",
	"step agreement element 5": "我们有一些关于你的细节，出于法律原因或者服务质量",
	"step agreement stats": "我允许Cozy收集匿名数据",
	"step agreement description 1": "你可以访问完整服务条款",
	"step agreement description 2": "点击“同意”按钮，表示你清楚你已阅读，了解，和同意这些条款。",
	"step agreement description link": "这里。",
	"step agreement next": "同意",
	"step preset": "设置",
	"step import": "导入你的数据",
	"step email settings": "配置你的电邮",
	"preset email": "电邮",
	"preset email tip": "当你丢失你的密码的时候这将会用来联系你。",
	"preset name": "姓名",
	"step password empty": "密码数值丢失。",
	"step password too weak": "你的密码太弱，你应该使用一个大写字母，一个数字，一个特殊符号或者更长的密码。",
	"step password title": "加强你的密码",
	"step password label": "密码",
	"step password input placeholder": "比如：\"dEj875ghj9273;eR\"",
	"step password submit": "确认",
	"step password show": "显示密码",
	"step password hide": "隐藏密码",
	"step password description": "你的密码必须足够复杂。这会防止那些不怀好意的人访问你的个人云。必须使用大写字母，数字，和特殊符号。",
	"step password server error": "出错了。你的密码没有保存。",
	"step infos title": "完整你的Cozy",
	"step infos description": "设置你的Cozy需要一些必要的信息。",
	"step infos public_name label": "用户名",
	"step infos public_name placeholder": "你的Cozy和你讲话时所用的公共名字。",
	"step infos email label": "电邮",
	"step infos email placeholder": "被你的Cozy用来重置密码。",
	"step infos timezone label": "时区",
	"step infos timezone placeholder": "你的时区可以帮助你的日历正确地显示。",
	"step infos submit": "确认",
	"step infos fetch data error": "无法从服务器获取数据。",
	"missing public_name": "你需要填写你的用户名。",
	"missing email": "你需要填写你的电邮。",
	"invalid email format": "你的电邮地址看起来不正确。",
	"missing timezone": "你需要选择时区。",
	"invalid timezone": "你的时区看起来不正确。",
	"step accounts title": "你的Cozy创建成功！",
	"step accounts description line 1": "现在，我们可以帮你连接你的Cozy到你的服务。",
	"step accounts description line 2": "最后，Cozy的目标是帮你收回你的数据。",
	"step accounts next": "浏览",
	"myaccounts info": "你现在随时可以按“继续”来访问你的Cozy。",
	"myaccounts next": "继续",
	"step confirmation title": "欢迎来到你的个人云！",
	"step confirmation description line 1": "你的Cozy已准备好。",
	"step confirmation description line 2": "你现在可以从众多服务商取回你的数据，和在我们的商店安装你想要的应用。",
	"step confirmation next": "进入",
	"step server error": "保存进度是发生错误。重新加载页面应该可以解决这个问题。",
	"preset name tip": "当你和人们分享文件或者邀请他们参加事件时会显示。",
	"preset password": "密码",
	"preset password tip": "强密码至少需要8个字符 (推荐特殊符号)",
	"preset timezone": "时区",
	"preset timezone tip": "为了你的日历正确地显示你的时区是必需的。",
	"preset opt-in help": "允许Cozy使用我的使用统计，以改善产品。",
	"preset opt-out newsletter": "订阅新闻(高度推荐)",
	"import from google": "从谷歌账号导入数据",
	"import google account": "Synchronize your Gmail account & import calendar, contacts and photos from Google",
	"import google account tip": "You'll need to sign in to your Google account to allow your Cozy to access to data hosted on Google",
	"leave google title": "Feed your data into Cozy",
	"leave google help me": "I don't understand what I have to do, please help me!",
	"leave google sign in content": "Sign in to your Google account and authorize your Cozy to access it. You will get a complex string. Copy it in your clipboard.",
	"leave google sign in": "登录到谷歌",
	"leave google code content": "Then, copy and paste the code from the popup in this field:",
	"leave google code": "google code",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Choose what you want to do with your data stored on Google servers:",
	"leave google choice sync gmail": "GMail - Access your email from Cozy",
	"leave google choice contacts": "One-time import of Google Contacts",
	"leave google choice calendar": "One-time import of Google Calendar",
	"leave google choice photos": "One-time import of Google Photos",
	"leave google confirm": "导入数据",
	"import error": "An error occurs when trying to import your datas. Please try again later from the dedicated app.",
	"login welcome user": "欢迎 %{username]",
	"login welcome anon": "欢迎",
	"login enter your password": "Enter your password to access your Cozy",
	"login password": "密码",
	"login otp": "认证代码",
	"login submit": "登录",
	"login auth success": "Authentication successful, let's go in!",
	"login recover": "Forgotten password? Send me an email to change it.",
	"login recover busy": "Sending an email containing instructions",
	"login recover sent title": "电邮已发送",
	"login recover sent message": "Please check your email, follow instructions to reset your password",
	"login recover error title": "Error sending mail",
	"login recover error message": "Error sending password recovery message, please check your MTA is running or contact server admin",
	"login wrong password title": "Wrong credentials",
	"login wrong password message": "The credentials you entered are incorrect. Please try again.",
	"login server error": "An error occured, please try again.",
	"reset password request success title": "电邮已发送",
	"reset password request success message": "Check your emails, and follow the instructions to change your password.",
	"reset password request error": "An error occurred, the email has not been sent. Please try again. If the error persists, contact us at contact@cozycloud.cc.",
	"reset welcome user": "Change your password",
	"reset enter your password": "%{username}, set a new password to recover access to your Cozy.",
	"reset password": "密码",
	"reset submit": "重置你的密码",
	"reset auth success": "密码重置成功",
	"reset wrong password title": "你的密码无法重置",
	"reset wrong password message": "The pasword you entered is incorrect, or your reset token is expired",
	"reset password error invalid key": "Your password request has expired. Please request a new one.",
	"reset password error password too weak": "Your password is too weak. You should add an uppercase, a number, a special character or a longer password.",
	"setup title": "We're setting up your Cozy…",
	"setup message": "You are now close to have your own personal cloud where your data are stored.",
	"setup on mobile title": "Synchronize your data with your Android device!",
	"setup on mobile message": "Check out our mobile app on Google Play:",
	"welcome title": "Congratulations on taking back control of your personal data!",
	"welcome message": "You can now store your data on your own personal cloud. As opposed to most cloud services, there is no data-mining taking place on your Cozy."
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/zh_CN.json
// module id = 49
// module chunks = 0